export const LICENCE_CONFIG_MAP = {
    "default": {
        "name": "Lemon Casino",
        "originalDomain": "lemon.casino",
        "logo-xmas": "assets/logo/lemon-logo-xmas-mobile.svg",
        "logo-desktop-xmas": "assets/logo/logo-xmas-desktop.svg",
        "logo": "assets/logo/logo-green.svg",
        "logo-desktop": "assets/logo/desktop-logo-125x32.svg",
        "logo-mobile": "assets/logo/mobile-logo-60x17.svg",
        // "logo-mobile" : "assets/logo/2024/logo-xmas-desktop.png",
        // "logo-desktop": "assets/logo/2024/logo-xmas-desktop.png",
        "full-logo": "assets/logo/logo-green.svg",
        "title-substitute": "",
        "icon-mission-logo": "assets/desktop/missions/tag-incomplete.svg",
        "icon-mission-completed": "assets/desktop/missions/tag-completed.svg",
        "arrow-icon": "assets/desktop/yellow-arrow.svg",
        "arrow-yellow-icon": "assets/desktop/yellow-arrow-old.svg",
        "pagination-arrow": "assets/desktop/pagination-arrow.svg",
        "new-yellow-arrow": "assets/icons/new-yellow-arrow-24x24.svg",
        "icon-edit-avater": "assets/icons/profile-edit-avater-button.svg",
        "icon-edit-no-outline-yellow": "assets/icons/icon-edit-no-outline-yellow.svg",
        "icon-dob": "assets/icons/icon-dob.svg",
        "edit-icon": "assets/icons/edit-icon.svg",
        "icon-adress": "assets/icons/adress.svg",
        "icon-exclamation": "assets/icons/icon-exclamation.svg",
        "icon-upload": "assets/icons/icon-upload.svg",
        "upload-docs-icon": "assets/images/upload-docs.svg",
        "pending-withdrawal": "assets/images/pending-withdrawal.svg",
        "icon-pending-withdrawals": "assets/icons/icon-pending-withdrawals.svg",
        "icon-pending-badge": "assets/icons/icon-pending-badge.svg",
        "icon-chevron-down-white": "assets/icons/icon-chevron-down-white.svg",
        "icon-vip-leef": "assets/icons/vip-leaves.svg",
        "icon-ham-btn": "assets/desktop/icon-ham-btn-white.svg",
        "icon-wallet-bonus-black": "assets/icons/wallet-bonus-icon.svg",
        "icon-password-lock": "assets/icons/icon-password-lock.svg",
        "icon-payment-not-available": "assets/icons/icon-not-available-payment.svg",
        "icon-bonus-drop": "assets/icons/pending-rewards-teaser.svg",
        "icon-copy": "assets/icons/icon-copy.svg",
        "icon-money-bag": "assets/icons/money-bag.svg",
        "icon-friends": "assets/icons/icon-friends.svg",
        "icon-avatar-friend": "assets/icons/icon-avatar-friend.png",
        "icon-tick-mark": "assets/icons/tick-mark.svg",
        "icon-reward-money-bag": "assets/icons/reward-money-bag.png",
        "icon-private": "assets/mobile/icon-private.svg",
        "icon-xmas-decor": "assets/icons/xmas/xmas-lemon-decor.png",
        "icon-xmas-lemon": "assets/icons/xmas/icon-xmas-lemon.png",
        "icon-loader-img": "assets/logo/logo-desktop.svg",
        "icon-category-specials": "assets/icons/icon-category-specials",
        "lemon-chips-stack-top": "assets/icons/lemon--chips-stack-top 1.png",
        "icon-wallet-small": "assets/icons/icon-wallet-small.svg",
        "icon-logout": "assets/icons/icon_logout.svg",
        "icon-delete": "assets/icons/icon-delete.svg",
        "bonus-excluded": "assets/icons/bonus-excluded.svg",
        "icon-fav": "assets/icons/fav-icon.svg",
        "icon-tag-big-win": "assets/icons/icon-tag-big-win.svg",
        "icon-tag-bonus-excluded": "assets/icons/icon-tag-bonus-excluded.svg",
        "icon-tag-hot": "assets/icons/icon-tag-hot.svg",
        "full-screen": "assets/icons/full-screen.svg",
        "vip-status-bronze": "assets/icons/lemons-levels/vip-bronze.png",
        "vip-status-silver": "assets/icons/lemons-levels/vip-silver.png",
        "vip-status-gold": "assets/icons/lemons-levels/vip-gold.png",
        "uploade-document-img": "assets/icons/uploade-document-img.png",
        "uploade-icon": "assets/icons/upload.png",
        "verification-icon": "assets/icons/verification.png",
        "verified-icon": "assets/icons/verified.png",
        "unverified-icon": "assets/icons/unverified.png",
        "icon-upload-btn": "assets/icons/icon-upload.png",
        "mobile-icon-upload": "assets/icons/mobile-icon-upload.png",
        "spino_drops": "assets/icons/spino_drops.png",
        "treassure-icon-close": "assets/icons/treassure-icon-close.svg",
        "treassure-mobile-close-icon": "assets/icons/mobile-close-icon.png",
        "icon-treasure-box": "assets/icons/icon-treasure-box.png",
        "reward-Vs": "assets/icons/reward-Vs.png",
        "high-reward": "assets/icons/t-boxes-img-high.png",
        "regular-reward": "assets/icons/t-boxes-img-regular.png",
        "bg-lottery-lemon": "assets/icons/bg-lottery-lemon.png",
        "bg-lottery-mobile-lemon": "assets/icons/bg-lottery-mobile-lemon.png",
        "icon-warn": "assets/icons/icon-warrning.png",
        "yellow-tag": "assets/icons/yellow-tag.png",
        "level-1": "assets/icons/level-1.png",
        "level-2": "assets/icons/level-2.png",
        "level-3": "assets/icons/level-3.png",
        "level-4": "assets/icons/level-4.png",
        "level-5": "assets/icons/level-5.png",
        "level-6": "assets/icons/level-6.png",
        "level-7": "assets/icons/level-7.png",
        "white-info-icon": "assets/icons/white-info-icon.svg",
        "icon-close-transparent": "assets/icons/icon-close-32x32.png",
        "down-arrow": "assets/icons/down-arrow-24-24.png",
        "client-area-info-icon": "assets/client-area/icon-new-info.svg",
        "icon-wheel": "assets/client-area/icon-wheel.svg",
        "icon-cashback": "assets/client-area/icon-cashback.svg",
        "icon-box": "assets/client-area/icon-box.svg",
        "icon-box-full": "assets/client-area/icon-box-full.svg",
        "icon-left-arrow": "assets/client-area/icon-left-arrow.svg",
        "icon-finished-inactive": "assets/icons/missions/icon-finished-inactive.svg",
        "icon-finished-flag": "assets/icons/missions/icon-finished-flag.svg",
        "icon-bet-coins": "assets/icons/missions/icon-bet-coins.svg",
        "inactive-icon-bet-coins": "assets/icons/missions/inactive-icon-bet-coins.svg",
        "inactive-union": "assets/icons/missions/inactive-union.svg",
        'active-union': "assets/desktop/missions/games.svg",
        "vip-default-arrow": "assets/icons/vip/default-arrow.svg",
        "vip-silver-arrow": "assets/icons/vip/silver-arrow.svg",
        "vip-gold-arrow": "assets/icons/vip/gold-arrow.svg",
        "vip-icon-tick": "assets/icons/vip/icon-tick-yes.svg",
        "vip-bronze-leave": "assets/icons/vip/vip-bronze-leave.svg",
        "vip-silver-leave": "assets/icons/vip/vip-silver-leave.svg",
        "vip-gold-leave": "assets/icons/vip/vip-gold-leave.svg",
        "vip-bronze-notification": "assets/icons/vip/bronze-notification.png",
        "vip-silver-notification": "assets/icons/vip/silver-notification.png",
        "vip-gold-notification": "assets/icons/vip/gold-notification.png",
        "info-icon": "assets/client-area/icon-new-info.svg",
        "vip-bronze-tag": "assets/icons/vip/VIP-bronze-tag.png",
        "vip-silver-tag": "assets/icons/vip/VIP-silver-tag.png",
        "vip-gold-tag": "assets/icons/vip/VIP-gold-tag.png",
        "icon-green-info":"assets/icons/icon-green-info.svg",
        "icon-jackpot":"assets/icons/icon-jackpot.svg",
        "icon-info-complaint":"assets/icons/icon-tourney-info.svg",
        "icon-profile-header":"assets/icons/icon-profile-header.svg",
        "edit-pencil":"assets/icons/edit-pencil.svg",
        "contact-icon-3D":"assets/icons/contact-icon-3D.svg",
        "right-circle-arrow":"assets/icons/right-circle-arrow.svg",
        "lock-icon-3D":"assets/icons/lock-icon-3D.svg",
        "left-arrow-icon":"assets/icons/left-arrow.svg",
        "telegram-icon":"assets/icons/telegram-icon-3D.svg",
        "close-icon":"assets/icons/icon-close-borderless.svg",
        "eye-on":"assets/desktop/eye-on.svg",
        "eye-off":"assets/desktop/eye-off.svg",
        "loyalty-hub-icon":"assets/icons/loyalty-hub-icon.svg",
        "icons-box-open-updated":"assets/icons/icons-box-open-updated.png",
        "btn-arrow-left":"assets/mobile/btn-arrow.svg",
        "btn-turn-off":"assets/mobile/btn-turn-off.svg",
        "btn-arrow-next":"assets/mobile/btn-arrow-next.svg",
        "game-info-search":"assets/desktop/game-info/game-info-search.svg",
        "game-info-resize":"assets/desktop/game-info/game-info-resize.svg",
        "game-info-close":"assets/desktop/game-info/game-info-close.svg",
        "game-favourites-off":"assets/desktop/game-info/game-favourites-off.svg",
        "game-favourites-on":"assets/desktop/game-info/game-favourites-on.svg",
        "icon-mission-mobile":"assets/mobile/icon-mission-mobile.svg",
        "icon-tournament-mobile":"assets/mobile/icon-tournament-mobile.svg",
        "wallet-icon-gl":"assets/icons/wallet-icon-gl.svg",
        "info":"assets/icons/info.svg",
        "info-active":"assets/icons/info-active.svg",
        "info-inactive":"assets/icons/info-inactive.svg",
        "shield-with-seven":"assets/icons/shield-with-seven.svg",
        "payment-completed":"assets/icons/payment-completed.svg",
        "payment-cancelled":"assets/icons/payment-cancelled.svg",
        "payment-created":"assets/icons/payment-created.svg",
        "icon-bonus-box":"assets/icons/icon-bonus-box.svg",
        "icon-trophy":"assets/icons/icon-trophy.svg",
        "icon-trophy-freeroll":"assets/icons/icon-trophy-freeroll.svg",

        "icon-number-1":"assets/icons/3d-number/number-1.svg",
        "icon-number-2":"assets/icons/3d-number/number-2.svg",
        "icon-number-3":"assets/icons/3d-number/number-3.svg",
        "icon-number-4":"assets/icons/3d-number/number-4.svg",

        "icon-down-arrow":"assets/icons/down-arrow.svg",
        "icon-right-arrow":"assets/icons/right-arrow-line.svg",
        "icon-time-left":"assets/desktop/icon-time-left.svg", 
        "vip-reward-gift":"assets/icons/icon-vip-bonus.png",
        "whatsapp-icon":"assets/icons/icon-whatsapp.svg",
        "vip-contact-icon":"assets/icons/icon-vip-contact.png",
        
        "icon-category-tournament":"assets/mobile/icon-category-tournament-32x32.svg",
        "mission-home-page-icon":"assets/icons/mission-home-page-icon.svg",
        "icon-lottery":"assets/icons/icon-lottery.svg",
        "icon-payment-faq":"assets/icons/icon-faq-payments.svg",
        "icon-promotion-faq":"assets/icons/icom-faq-promotion.svg",
        "deposit-add-icon": "assets/icons/icon-add.svg",
        "balance-deposit-add-icon": "assets/icons/balance-deposit-add-icon.svg",
        "icon-img-bonus-box": "assets/icons/icon-bonus-box-payment-new.svg",
        "icon-img-boosted-bonus-box": "assets/icons/icon-boosted-bonus-box.png",
        "icon-info-dark": "assets/icons/icon-info-green.svg",
        "icon-info-yellow": "assets/icons/icon-info-new.svg",
        "icon-info-blue": "assets/icons/icon-info-blue.svg",
        "icon-info-minus": "assets/icons/icon-none-round.svg",
        "teasure-banner-img": "assets/icons/teaser-banner.png",
        "teasure-banner-img-mobile": "assets/icons/teaser-banner-boosted.png",
        "add-gradient-bg": "assets/icons/deposit-bonus-add-btn.svg",
        "swap-gradient-bg": "assets/icons/icon-refresh.svg",
        "bonus-offer-img": "assets/icons/icon-bonus.svg",
        "random-game": "assets/images/random-game.png",
        "random-game-thumbnail": "assets/images/random-game-thumbnail.png",
        "icon-pay-history": "assets/desktop/pay-history.svg",
        "icon-deposit": "assets/icons/icon-deposit.svg",
        "icon-withdrawal-up-arrow": "assets/icons/icon-withdrawal-up-arrow.svg",
        "icon-sportsbook": "assets/icons/icon-menu-sportsbook.svg",
        "icon-info-red": "assets/icons/icon-info-red.svg"
    },
    "orange_curacao": {
        "logo": "assets/logo/orange-logo.svg",
        "logo-mobile": "assets/logo/orange-logo.svg",
        "logo-desktop": "assets/logo/orange-logo.svg",
        "icon-loader-img": "assets/logo/orange-logo.svg",
        "full-logo": "assets/logo/orange-logo.svg",
        "title-substitute": "Orange Casino",

    }
}

